import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { enum_api_uri } from "../utils/enum";

interface Request {
    s_bl_no: string;
}

interface Response {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

export const useDeleteConsoleBlImages = (): UseMutationResult<Response, Error, Request, unknown> => {
    // const queryClient = useQueryClient();

    return useMutation<Response, Error, Request>({
        mutationFn: async (data: Request) => {
            const url = enum_api_uri.delete_console_bl_images;

            const response = await axiosInstance.delete(url, {
                data: { s_bl_no: data.s_bl_no },
            });
            return response.data;
        },
        onSuccess: data => {
            return data;
        },
    });
};
